import React from "react";
import { motion } from "framer-motion";
import "./ContactPage.css";
import SEO from "../components/SEO/SEO";

export default function ContactPage() {

  return (
    <>
    <SEO
     title="Contact BuildNear | Customer Support"
      description="Contact BuildNear for dealer registration, business enquiries and customer support."
      keywords="BuildNear contact, dealer support, customer support"
      url="https://buildnear.in/contact"
/>
    <div className="contact-page">

      {/* Hero */}
      <section className="contact-hero">

        <motion.div
          className="contact-hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >

          <h1>
            Let's Build Something <span>Great</span>
          </h1>

          <p>
            Have questions about dealers, partnerships or services?
            Our team is ready to help you.
          </p>

        </motion.div>

      </section>


      {/* Contact Cards */}

      <section className="contact-container">


        <motion.div
          className="contact-card"
          whileHover={{ y: -8 }}
        >

          <div className="contact-icon">
            📍
          </div>

          <h3>
            Office Address
          </h3>

          <p>
            BuildNear Headquarters<br/>
            Bengaluru, Karnataka<br/>
            India
          </p>

        </motion.div>



        <motion.div
          className="contact-card"
          whileHover={{ y: -8 }}
        >

          <div className="contact-icon">
            📞
          </div>

          <h3>
            Call Us
          </h3>

          <p>
            +91 XXXXX XXXXX
            <br/>
            Mon - Sat | 9 AM - 6 PM
          </p>

        </motion.div>



        <motion.div
          className="contact-card"
          whileHover={{ y: -8 }}
        >

          <div className="contact-icon">
            ✉️
          </div>

          <h3>
            Email
          </h3>

          <p>
            support@buildnear.com
            <br/>
            partnerships@buildnear.com
          </p>

        </motion.div>


      </section>



      {/* Contact Form */}

      <section className="contact-form-section">


        <motion.div
          className="contact-form-card"
          initial={{opacity:0}}
          whileInView={{opacity:1}}
          transition={{duration:0.5}}
        >

          <h2>
            Send Us A Message
          </h2>


          <form>

            <div className="form-row">

              <input
                type="text"
                placeholder="Your Name"
              />

              <input
                type="email"
                placeholder="Email Address"
              />

            </div>


            <input
              type="text"
              placeholder="Phone Number"
            />


            <textarea
              rows="5"
              placeholder="Your Message"
            />


            <button>
              Submit Request
            </button>


          </form>


        </motion.div>


      </section>


    </div>
    </>
  );
}